module.exports = __webpack_public_path__ + "static/media/15 - Ting.d9792ef7.wav";